import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import { orderTypeTakeaways, takeawayRule } from "@/mocks/orderTypes";

export default function OrderTakeaway() {
  return (
    <section className="px-4 md:px-8 py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="mb-2.5 flex items-center gap-3">
            <Eyebrow>Quick recap</Eyebrow>
            <span className="h-px flex-1 bg-foreground-950/15"></span>
          </div>
          <div className="border-2 border-foreground-950 bg-background-100">
            {/* Four one-liners */}
            <div className="grid grid-cols-1 md:grid-cols-4">
              {orderTypeTakeaways.map((item, index) => (
                <div
                  key={item.key}
                  className={`flex items-baseline gap-2.5 px-4 md:px-5 py-3.5 border-b-2 border-foreground-950 md:border-b-0 ${
                    index < orderTypeTakeaways.length - 1 ? "md:border-r-2" : ""
                  }`}
                >
                  <span className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">
                    0{index + 1}
                  </span>
                  <p className="font-heading font-bold uppercase tracking-tight text-sm leading-snug text-foreground-950">
                    {item.gain} —{" "}
                    <span className="font-black text-accent-600">{item.cost}</span>.
                  </p>
                </div>
              ))}
            </div>

            {/* The rule */}
            <div className="flex items-center gap-2.5 px-4 md:px-5 py-3 border-t-2 border-foreground-950 bg-primary-500">
              <p className="font-heading font-bold uppercase tracking-tight text-sm leading-snug text-foreground-950">
                {takeawayRule}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}